import { render, staticRenderFns } from "./Exito.vue?vue&type=template&id=0bb209e3&scoped=true&"
import script from "./Exito.vue?vue&type=script&lang=js&"
export * from "./Exito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb209e3",
  null
  
)

export default component.exports